module.exports = __webpack_public_path__ + "img/step2-mobile-en.ccca847a.webp";